module.exports = __webpack_public_path__ + "static/media/offeract.64491c47.svg";